import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import type { EventTriggerPopupData } from '../../../../../stores/event-trigger/types';
import { useStores } from '../../../../../stores/useStores';
import { DEFAULT_TIMER } from '../../../../../utils/time';
import { GeneralWidgetTimer } from '../../GeneralWidget';

interface EventTriggerWidgetTimerProps {
  event: EventTriggerPopupData;
  extended?: boolean;
}

function EventTriggerWidgetTimerComponent(props: EventTriggerWidgetTimerProps) {
  const { event, extended } = props;
  const { eventTriggerStore } = useStores();
  const { t } = useTranslation();
  const timer = eventTriggerStore.getEventTimerFormatted(event.userEventTriggerId, t);

  return <GeneralWidgetTimer extended={extended} timerValue={timer || DEFAULT_TIMER} />;
}

export const EventTriggerWidgetTimer = observer(EventTriggerWidgetTimerComponent);
